import React, { useState, useEffect } from "react";
import { Route, Routes ,Navigate} from "react-router-dom";
import Login from "./Auth/Login";
import CheckUser from "./Functions/Both/CheckUser";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./Components/Firebase";

//Admin
import Home from "./Admin/Home";
import SHome from "./Sapakim/SHome";
import ViewSapakim from "./Admin/ViewSapakim";
import AddNewSapak from "./Admin/AddNewSapak";
import ViewSapak from "./Admin/ViewSapak";
import ViewSapakOrders from './Admin/ViewSapakOrders'
import ViewOrder from './Admin/ViewOrder'
import ViewCustomers from './Admin/ViewCustomers'
import AddNewCustomer from './Admin/AddNewCustomer'
import ViewCustomerProfile from './Admin/ViewCustomerProfile'
import CreateNewOrder from './Admin/CreateNewOrder'
import ViewAllOrders from './Admin/ViewAllOrders'
import Quotations from './Admin/Quotations'
import ViewQuotation from './Admin/ViewQuotation'
import Catalog from './Admin/Catalog'
import EditCategory from './Admin/EditCategory'
import Ads from "./Admin/Ads";
import Docs from "./Admin/Docs";
//Sapakim
import SViewCustomers from "./Sapakim/SViewCustomers";
import SAddNewCustomer from "./Sapakim/SAddNewCustomer";
import SViewCustomerProfile from "./Sapakim/SViewCustomerProfile";
import SCreateNewOrder from "./Sapakim/SCreateNewOrder";
import SViewOrder from './Sapakim/SViewOrder'
import SViewAllOrders from './Sapakim/SViewAllOrders'
import SQuotations from './Sapakim/SQuotations'
import SCreateNewQuotation from './Sapakim/SCreateNewQuotation'
import SViewQuotation from './Sapakim/SViewQuotation'
import SCatalog from './Sapakim/SCatalog'
import SViewItem from "./Sapakim/SViewItem";
import SDocs from "./Sapakim/SDocs";

const RedirectIfLoggedIn = () => {
  const [loading, setLoading] = useState(true);
  const [userUID, setUserUID] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserUID(user.uid);
      } else {
        setUserUID(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <div>Loading...</div>;

  if (userUID) {
    return <Navigate to={`/CheckUser/${userUID}`} replace />;
  }

  return <Login />;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<RedirectIfLoggedIn />} />

      <Route path="/CheckUser/:UID" element={<CheckUser />} />

      {/* Admin */}
      <Route path="/AdminHome/:UID" element={<Home />} />
      <Route path="/AdminHome/:UID/ViewSapakim" element={<ViewSapakim />} />
      <Route path="/AdminHome/:UID/ViewSapakim/AddNewSapak" element={<AddNewSapak />} />
      <Route path="/AdminHome/:UID/ViewSapakim/:SUID" element={<ViewSapak />} />
      <Route path="/AdminHome/:UID/ViewSapakim/:SUID/ViewSapakOrders" element={<ViewSapakOrders />} />
      <Route path="/AdminHome/:UID/ViewOrder/:CUID/:ORID" element={<ViewOrder />} />
      <Route path="/AdminHome/:UID/ViewCustomers" element={<ViewCustomers />} />
      <Route path="/AdminHome/:UID/ViewCustomers/AddNewCustomer" element={<AddNewCustomer />} />
      <Route path="/AdminHome/:UID/ViewCustomers/:CDID" element={<ViewCustomerProfile />} />
      <Route path="/AdminHome/:UID/ViewCustomers/:CDID/CreateNewOrder" element={<CreateNewOrder />} />
      <Route path="/AdminHome/:UID/ViewAllOrders" element={<ViewAllOrders />} />
      <Route path="/AdminHome/:UID/ViewQuotations" element={<Quotations />} />
      <Route path="/AdminHome/:UID/ViewQuotation/:QUID" element={<ViewQuotation />} />
      <Route path="/AdminHome/:UID/Catalog" element={<Catalog />} />
      <Route path="/AdminHome/:UID/Catalog/:CID" element={<EditCategory />} />
      <Route path="/AdminHome/:UID/Ads" element={<Ads />} />
      <Route path="/AdminHome/:UID/Docs/:SUID" element={<Docs />} />
      <Route path="/AdminHome/:UID/SCreateNewOrder" element={<SCreateNewOrder />} />
      {/* Sapakim */}
      <Route path="/SapakimHome/:UID" element={<SHome />} />
      <Route path="/SapakimHome/:UID/SViewCustomers" element={<SViewCustomers />} />
      <Route path="/SapakimHome/:UID/SViewCustomers/SAddNewCustomer" element={<SAddNewCustomer />} />
      <Route path="/SapakimHome/:UID/SViewCustomers/:CDID" element={<SViewCustomerProfile />} />
      <Route path="/SapakimHome/:UID/SViewCustomers/:CDID/SCreateNewOrder" element={<SCreateNewOrder />} />
      <Route path="/SapakimHome/:UID/SViewCustomers/:CDID/SViewOrder/:ORID" element={<SViewOrder />} />
      <Route path="/SapakimHome/:UID/SViewAllOrders" element={<SViewAllOrders />} />
      <Route path="/SapakimHome/:UID/SQuotations" element={<SQuotations />} />
      <Route path="/SapakimHome/:UID/SQuotations/SCreateNewQuotation" element={<SCreateNewQuotation />} />
      <Route path="/SapakimHome/:UID/SQuotations/:CDID/:QUID" element={<SViewQuotation />} />
      <Route path="/SapakimHome/:UID/SCatalog" element={<SCatalog/>} />
      <Route path="/SapakimHome/:UID/SCatalog/:iid" element={<SViewItem/>} />
      <Route path="/SapakimHome/:UID/SDocs" element={<SDocs />} />
    </Routes>
  );
}

export default App;